import { AuthLayout } from '../components/AuthLayout';

export const Register = () => {
  return <AuthLayout page="register" />;
};
